<template>
    <nav v-if="!loading" class="w-full z-30 sticky top-0" :class="[notSmallScreen ? 'shadow-md py-4 flex justify-center items-center bg-white' : 'relative bg-brand md:bg-white'
     ]">
        <!--Desktop-->
        <div v-if="notSmallScreen" class="grid grid-cols-12 gap-x-4 items-center max-w-12xl px-2 lg:px-8 w-full">
            <div class="col-span-2 lg:col-span-3 flex justify-start">
                <a href="/" title="Home Dashboard" class="p-1 rounded bg-brand">
                    <img class="h-8 w-8" src="/images/rabbit_white.svg" alt="RedRabbit logo" style="min-width: 32px; min-height: 32px"/>
                </a>
            </div>

            <div class="col-span-8 lg:col-span-6">
                <div class="flex justify-center items-center space-x-3">
                    <top-nav-button v-for="button in mainButtons"
                                    v-if="!button.onlyOnMobile"
                                    :icon-selection="button.iconSelection"
                                    :main-button="button" :is-selected="isSelectedNavButton(button)"
                                    :sub-buttons="button.subButtons" :key="(Math.random() * 999999).toFixed(0)"></top-nav-button>
                </div>
            </div>

            <div class="col-span-12 lg:col-span-3">
                <div class="flex justify-center lg:justify-end items-center space-x-4">
                    <help-list></help-list>

                    <system-notification-list></system-notification-list>

                    <!-- Profile dropdown -->
                    <simple-dropdown button-class="">
                        <template slot="labelHeader">
                            <span class="flex items-center justify-center select-none">
                                <span
                                    class="text-xl font-medium leading-none mr-1">{{ state.user.first_name && state.user.first_name.length <= 15 ? state.user.first_name : state.user.initials }}
                                </span>
                                <icon-chevron-down class="w-4 h-4 transform transition duration-300"
                                                   :class="showProfileDropdown ? 'rotate-90' : ''"></icon-chevron-down>
                            </span>
                        </template>

                        <template slot="additionalInfo">
                            <div class="py-1 font-normal">
                                <div class="block px-4 mt-2 text-md leading-5 text-gray-900 font-medium transition duration-150 ease-in-out">
                                    {{ state.currentTeam.trading_name }}
                                </div>
                                <div class="block px-4 mb-3 text-md leading-5 text-gray-400 transition duration-150 ease-in-out break-all">
                                    {{ state.user.email }}
                                </div>
                                <div class="border-b border-gray-200 mb-2" aria-hidden="true"></div>
                            </div>
                        </template>

                        <template slot="buttonOptions">
                            <simple-dropdown-option value="Your Profile" @click="reroute(routes.profile)">
                                Your Profile
                            </simple-dropdown-option>
                            <simple-dropdown-option value="Company Settings" @click="reroute(routes.settings)">
                                Company Settings
                            </simple-dropdown-option>
                            <simple-dropdown-option value="Support Lab" v-if="app.state.is_support" @click="reroute(routes.support_lab)">
                                Support Lab
                            </simple-dropdown-option>
                            <simple-dropdown-option value="Log Out" button-class="flex">
                                <a href="#" onclick="event.preventDefault();document.getElementById('logout-form-desktop').submit();" class="w-full">Logout
                                    <form id="logout-form-desktop" action="/logout" method="POST" class="hidden">
                                        <input type="hidden" name="_token" id="csrf-token" :value="app.csrfToken"/>
                                    </form>
                                </a>
                            </simple-dropdown-option>
                        </template>
                    </simple-dropdown>
                </div>
            </div>
        </div>

        <!--MOBILE-->
        <div v-if="!notSmallScreen" class="shadow-md">
            <div class="flex justify-between items-center relative py-4">
                <div class="-ml-2 mr-2 flex items-center">
                    <!-- Mobile menu button -->
                    <button
                        class="ml-1 inline-flex items-center justify-center p-2 rounded text-gray-100 bg-brand hover:text-white focus:outline-none focus:text-white transition duration-150 ease-in-out"
                        aria-label="Main menu" aria-expanded="false"
                        @click="toggleMobileMenu">

                        <!-- Icon when menu is closed. -->
                        <svg v-show="!showMobileMenu" class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
                        </svg>

                        <!-- Icon when menu is open. -->
                        <svg v-show="showMobileMenu" class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>

                    <div class="text-white font-semibold text-xl p-1 lg:hidden">
                        RedRabbit
                    </div>
                </div>

                <div class="flex">
                    <help-list :class="[showMobileMenu ? 'hidden' : 'mr-3']"></help-list>

                    <system-notification-list :class="[showMobileMenu ? 'hidden' : 'mr-3']"></system-notification-list>
                </div>
            </div>

            <div v-show="showMobileMenu" class="md:hidden absolute top-18 left-0 z-50 overflow-y-visible bg-brand min-w-full shadow-lg">
                <div class="border-t-2 border-indigo-400 px-2 pb-3 sm:px-3">
                    <top-nav-button-mobile v-for="button in mainButtons" :main-button="button" :sub-buttons="button.subButtons"
                                           :key="(Math.random() * 999999).toFixed(0)"></top-nav-button-mobile>
                </div>

                <div class="pt-4 pb-3 border-t-2 border-indigo-400">
                    <div class="flex items-center px-5 sm:px-6">
                        <span class="inline-flex items-center justify-center h-10 w-10 rounded-full bg-white">
                            <span class="text-md font-medium leading-none text-brand">{{ state.user.initials }}</span>
                        </span>

                        <div class="ml-3 text-white">
                            <div class="text-base font-medium leading-6 ">{{ state.user.name }}</div>
                            <div class="text-sm font-medium leading-5 break-all">{{ state.user.email }}</div>
                        </div>
                    </div>

                    <div class="mt-3 px-2 sm:px-3 text-white">
                        <a :href="routes.profile"
                           class="block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out">Your Profile</a>
                        <a :href="routes.settings"
                           class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out">Company Settings</a>
                        <a class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-white focus:outline-none focus:text-white focus:bg-gray-700 transition duration-150 ease-in-out"
                           href="#" onclick="event.preventDefault();document.getElementById('logout-form-mobile').submit();">Logout
                            <form id="logout-form-mobile" action="/logout" method="POST" style="display: none; width: 100%">
                                <input type="hidden" name="_token" id="csrf-token" :value="app.csrfToken"/>
                            </form>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import TopNavButton from "./TopNavButton";

export default {
    name: "Navbar",

    components: {TopNavButton},

    data () {
        return {
            loading: true,
            showMobileMenu: false,
            showProfileDropdown: false,
            mainButtons: {
                dashboard: {text: "Dashboard", url: "/", iconSelection: "", subButtons: [], onlyOnMobile: true},

                inbox: {text: "Inbox", url: "/inbox", iconSelection: "inbox", subButtons: []},

                maintenance: {
                    text: "Maintenance", url: "/tickets", iconSelection: "maintenance",
                    subButtons: [{text: "Tickets", url: "/tickets"}, {text: "Maintenance Requests", url: "/maintenance/requests"}]
                },

                inspections: {
                    text: "Inspections", url: "/inspections", iconSelection: "inspections", subButtons: [],
                },

                portfolio: {
                    text: "Portfolio", url: "/assets", iconSelection: "data",
                    subButtons: [{text: "Assets", url: "/assets"}, {text: "Asset Groups", url: "/assets/groups"},
                        {text: "Service Providers", url: "/serviceproviders"}, {text: "Contacts", url: "/contacts"}]
                },

                reporting: {
                    text: "Reporting", url: "/reporting", iconSelection: "reporting",
                    subButtons: [{text: "Reporting", url: "/reporting"}, {text: "Activity Log", url: "/activity-log"}]
                },
            },
            routes: {},
        };
    },

    computed: {
        selectedNavButton () {
            return location.pathname;
        }
    },

    mounted () {
        this.setupRoutes();

        if (this.userHasRole("Support")) {
            this.mainButtons.inspections.subButtons.push({text: "Inspections", url: "/inspections"});
            this.mainButtons.inspections.subButtons.push({text: "Inspection Reminders", url: "/reminders"});
        }

        this.loading = false;
    },

    methods: {
        setupRoutes () {
            // Can only set route in method because this.state is not available in data()
            this.routes = {
                profile: "/users/profile/" + this.state.user.id,
                settings: "/settings",
                knowledge_base: "https://help.redrabbit.zone",
                support_lab: "/admin/resources/teams"
            };
        },

        toggleMobileMenu () {
            this.showMobileMenu = !this.showMobileMenu;
        },

        toggleProfileDropdown () {
            this.showProfileDropdown = !this.showProfileDropdown;
        },

        hideProfileDropdown () {
            this.showProfileDropdown = false;
        },

        isSelectedNavButton (button) {
            if (button.subButtons.length > 0) {
                // check if one of the sub buttons' url is equal to the currently selected button's url
                return button.subButtons.map(sub => {
                    return sub.url;
                }).some(url => this.selectedNavButton.includes(url));
            }

            // when no sub button, check if the main button's url is equal to the currently selected button's url
            return button.url === this.selectedNavButton;
        },

        reroute (url) {
            window.open(
                url,
                "_blank"
            );
        }
    },
};
</script>
